import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { useUnreadAnnouncementsStyles } from './styles/unread-announcement.styles';
import { useAnnouncementReadStatus } from '../../hooks';
import {
  Announcement,
  AnnouncementReadSignal,
  AnnouncementSignal,
  AnnouncementSubscribeSignal,
  SIGNALS_CHANNEL_ANNOUNCEMENTS,
  SIGNALS_CHANNEL_ANNOUNCEMENTS_READ,
  SIGNALS_CHANNEL_SUBSCRIPTION,
  SIGNALS_CHANNEL_UNSUBSCRIPTION,
} from '@internal/backstage-plugin-announcements-common';
import { useSignal } from '@backstage/plugin-signals-react';
// import { AnnouncementProvider } from './state/announcement.state';

export const UnReadAnnoucement = () => {
  const classes = useUnreadAnnouncementsStyles();
  // const announcementsApi = useApi(announcementsApiRef);

  // const lastSeen = announcementsApi.lastSeenDate();
  // const [lastSeen, setLastSeen] = useState(announcementsApi.lastSeenDate());
  const [signaledAnnouncement, setSignaledAnnouncement] = useState<
    Announcement | undefined
  >();

  const [lastReadIds, setLastReadIds] = useState<string[]>([]);

  const { lastSignal } = useSignal<AnnouncementSignal>(
    SIGNALS_CHANNEL_ANNOUNCEMENTS,
  );
  const { lastSignal: readSignal } = useSignal<AnnouncementReadSignal>(
    SIGNALS_CHANNEL_ANNOUNCEMENTS_READ,
  );
  const { lastSignal: subscriptionSignal } =
    useSignal<AnnouncementSubscribeSignal>(SIGNALS_CHANNEL_SUBSCRIPTION);

  const { lastSignal: unsubscriptionSignal } =
    useSignal<AnnouncementSubscribeSignal>(SIGNALS_CHANNEL_UNSUBSCRIPTION);
  const { value, retry, loading, error } = useAnnouncementReadStatus();
  const [refresh, setRefresh] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  // const { announcements, retry: refresh } = useAnnouncements({});
  useEffect(() => {
    if (refresh) {
      retry();
      setRefresh(false);
    }
  }, [refresh, retry]);

  useEffect(() => {
    if (!lastSignal || lastSignal.data === signaledAnnouncement) {
      return;
    }

    setSignaledAnnouncement(lastSignal?.data);
    setRefresh(true);
  }, [lastSignal, refresh, signaledAnnouncement]);

  useEffect(() => {
    if (
      !readSignal ||
      JSON.stringify(readSignal.announcement_ids.sort()) ===
        JSON.stringify(lastReadIds.sort())
    ) {
      return;
    }

    setLastReadIds(readSignal.announcement_ids);
    setRefresh(true);
  }, [lastReadIds, readSignal]);

  useEffect(() => {
    if (!loading && !error && value) {
      setUnreadCount(value.unread);
    }
  }, [loading, error, value]);

  useEffect(() => {
    if (subscriptionSignal || unsubscriptionSignal) {
      setRefresh(true);
    }
  }, [subscriptionSignal, unsubscriptionSignal]);

  let count: number | string | undefined;
  if (!error && unreadCount > 0) {
    count = unreadCount > 99 ? '99+' : unreadCount;
  }
  if (!count) {
    return null;
  }

  return <Box className={classes.kindItemCountContainer}>{count}</Box>;
};
